<script>
import { mapMutations } from 'vuex';
import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import DropZoneSingle from '@/components-user/smart/template/drop-zone-single';
import {
    SET_VALIDATION_ERRORS,
} from '@/store/types/mutation-types';

const CUSTOM_ATTR_NAME = 'form-data';

export default {
    name: 'o-form-container',
    extends: DropZoneSingle,
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Form',
        },

        tagDefault: {
            type: String,
            default: 'form',
        },
    },

    created() {
        if (!this.hasElementData(CUSTOM_ATTR_NAME)) {
            this.setElementData(CUSTOM_ATTR_NAME, { method: 'POST' }, { triggerChangeDetection: false });
        }
    },

    mounted() {
        const { method } = this.getElementData(CUSTOM_ATTR_NAME);
        if (method?.toLowerCase() === 'query') {
            const urlParams = new URLSearchParams(window.location.search);
            const inputs = [].slice.call(this.$el.querySelectorAll('input'));
            const texts = [].slice.call(this.$el.querySelectorAll('textarea'));
            urlParams.forEach((value, key) => {
                const splitValues = value.split('|');
                const matchInputs = inputs.filter(e => e.name === key);
                if (matchInputs.length > 0) {
                    // for multi value, one per input
                    if (splitValues.length > 1 && matchInputs.length === splitValues.length) {
                        let i;
                        for (i = 0; i < splitValues.length; i++) {
                            matchInputs[i].value = splitValues[i];
                        }
                    } else { // otherwise, all inputs get same value
                        matchInputs.forEach((input) => {
                            input.value = value;
                        });
                    }
                }
                const matchTexts = texts.filter(e => e.name === key);
                if (matchTexts.length > 0) {
                    // for multi value, assume one per input
                    if (splitValues.length > 1) {
                        let i;
                        for (i = 0; i < splitValues.length; i++) {
                            matchTexts[i].value = splitValues[i];
                        }
                    } else { // for single value, all inputs get same value
                        matchTexts.forEach((input) => {
                            input.value = value;
                        });
                    }
                }
            });
        }
    },

    methods: {
        ...mapMutations({
            setValidationErrors: SET_VALIDATION_ERRORS,
        }),

        submitForm() {
            const e = new Event('submit');
            this.$el.dispatchEvent(e);
        },

        validateElement() {
            this.validationErrors = [];
            const $submitButton = this.$el.querySelector('button[type="submit"]');
            if (!$submitButton) {
                this.addValidationError(this, 'A submit button is required');
            }
            this.setValidationErrors({ element: this, messages: this.validationErrors });
        },
    },
};
</script>
